import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { Input } from "../../../../library/input";
import { sendErrorNotification } from "../../../../universal/notifications/notifications";
import { TransparentButton, SolidButton } from "../../../../library/button";
import { Popup } from "../../../../library/popup";
import { Label } from "../../../../library/label";
import { ToastContainer } from "react-toastify";
import "./style.scss";
import {
  changeCompanyModal,
  requestAddPaymentMethod,
} from "../../../../../redux/actions/company";

const Index = () => {
  const dispatch = useDispatch();
  const modalState = useSelector(
    (state) => state.company.showModals.addPaymentMethod
  );
  const companyId = useSelector(
    (state) => state.activeCompany.activeCompany.id
  );

  const addError = useSelector((state) => state.company.addPaymentMethod.error);
  const addLoading = useSelector(
    (state) => state.company.addPaymentMethod.loading
  );

  const [cardDetails, setCardDetails] = useState({
    name: null,
    number: null,
    expiration: null,
    cvc: null,
  });

  const resetCardDetails = () => {
    setCardDetails({
      name: null,
      number: null,
      expiration: null,
      cvc: null,
    });
  };

  const handleClose = () => {
    dispatch(changeCompanyModal({ addPaymentMethod: false }));
    resetCardDetails();
  };

  const clickAddMethod = () => {
    if (
      cardDetails.name &&
      cardDetails.number &&
      cardDetails.expiration &&
      cardDetails.cvc
    ) {
      dispatch(
        requestAddPaymentMethod({ companyId: companyId, card: cardDetails })
      );
    } else {
      sendErrorNotification("Vennligst fyll inn alle felt.");
    }
  };

  useEffect(() => {
    if (addError) {
      sendErrorNotification(addError);
    }
  }, [addError]);

  return (
    <Popup
      onClose={handleClose}
      show={modalState}
      title="Legg til nytt kort"
      buttons={[
        <TransparentButton
          title="Avbryt"
          type="button"
          data-dismiss="modal"
          onClick={() => handleClose()}
        />,
        <SolidButton
          color="blue"
          title={addLoading ? "Legger til.." : "Legg til"}
          icon={
            addLoading ? (
              <i className="fas fa-circle-notch fa-spin"></i>
            ) : (
              <i class="fad fa-plus"></i>
            )
          }
          onClick={() => clickAddMethod()}
          type="button"
        />,
      ]}
    >
      <div className="add-payment-method-popup-content">
        <Row className="info-row">
          <Col className="info-col">
            <Label version={1} weight="bold">
              Fullt navn
            </Label>
            <Input
              value={cardDetails.name}
              onChange={(e) =>
                setCardDetails({ ...cardDetails, name: e.target.value })
              }
              placeholder="Skriv inn et navn"
              type="text"
            />
          </Col>
        </Row>
        <Row className="info-row">
          <Col className="info-col">
            <Label version={1} weight="bold">
              Kortnummer
            </Label>
            <Input
              value={cardDetails.number}
              onChange={(e) =>
                setCardDetails({ ...cardDetails, number: e.target.value })
              }
              placeholder="Skriv inn"
              type="text"
            />
          </Col>
        </Row>
        <Row className="info-row">
          <Col className="info-col">
            <Label version={1} weight="bold">
              Utløpsdato
            </Label>
            <Input
              value={cardDetails.expiration}
              onChange={(e) =>
                setCardDetails({ ...cardDetails, expiration: e.target.value })
              }
              format="expiration"
              placeholder="MM/YYYY"
              type="text"
            />
          </Col>
          <Col className="info-col small">
            <Label version={1} weight="bold">
              CVC
            </Label>
            <Input
              value={cardDetails.cvc}
              onChange={(e) =>
                setCardDetails({ ...cardDetails, cvc: e.target.value })
              }
              format="pin"
              placeholder="CVC"
              type="password"
            />
          </Col>
        </Row>
        <small>
          Kortinformasjonen din vil bli lagret trygt hos stripe.com.
        </small>
      </div>
      <ToastContainer />
    </Popup>
  );
};

export default Index;
